import React from 'react';
import {Button, Stack} from '@mui/material';
import {AppointmentBookingEnum, OdontoBookingTaggingEnum} from 'main/analytics/gaTagsEnum';
import Icon from 'presentation/icons';
import {openGoogleMaps} from 'presentation/modules/booking/shared/utils/openGoogleMaps';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {getAddressforMaps} from 'presentation/utils';
import {ReviewCard} from '../ReviewCard';
import {ProviderAddressFieldProps} from './types';
import {useBookingSummary} from 'presentation/modules/booking/shared/hooks/useBookingSummary';
import {FlowEnum} from '../../../constants/flowEnum';
import {ChangeFlowVariantEnum} from '../ChangeFlowDialog/constants';

import {formatOdontoRecommendations} from 'presentation/modules/booking/odonto/utils/formatOdontoRecommendations';
import {OdontoRecommendations} from 'presentation/modules/booking/odonto/ui/components/OdontoRecommendations';

const {attendanceUnit, attendance, observations} = translations['pt-br'].commons;
const {openMap} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow.unitDetails;

export function ProviderAddressField({flowType}: ProviderAddressFieldProps) {
	const {isTablet} = useMediaQueries();
	const {handleChangeModals} = useBookingSummary();
	const bookingData = useBookingStore(state => state.bookingData);

	const isTelehealth = flowType === FlowEnum.TELEHEALTH;
	const isOdonto = flowType === FlowEnum.ODONTO;

	const address = getAddressforMaps(bookingData.unitAddress);

	const handleOpenGoogleMaps = () => openGoogleMaps(address.addressForMaps || '');

	return (
		<ReviewCard.Root>
			<ReviewCard.Header
				handleAction={
					isTelehealth ? undefined : () => handleChangeModals(ChangeFlowVariantEnum.UNIT)
				}
				subheader={isTelehealth ? attendance : attendanceUnit}
				actionDataTagId={AppointmentBookingEnum.CLICK_ALTERAR_INFORMACOES_AGENDAMENTO}
			/>
			<ReviewCard.Content
				iconName={isTelehealth ? 'remember-me-filled' : 'location-on-filled'}
				primaryText={bookingData.unitName}
				secondaryText={bookingData.unitAddress}
			/>
			{isTelehealth ? null : (
				<Stack alignItems={'flex-end'} mt={2}>
					<Button
						data-tag-id={OdontoBookingTaggingEnum.CLICK_VER_COMO_CHEGAR}
						sx={{minWidth: 'fit-content'}}
						onClick={handleOpenGoogleMaps}
						fullWidth={isTablet}
						variant="outlined"
						endIcon={<Icon name="map" />}>
						{openMap}
					</Button>
				</Stack>
			)}
			{isOdonto && bookingData.odontoRecommendations ? (
				<OdontoRecommendations
					subheader={observations}
					hasDivider
					noPadding
					recommendations={formatOdontoRecommendations([
						bookingData?.odontoRecommendations,
					])}
				/>
			) : null}
		</ReviewCard.Root>
	);
}
